/**
 * Created by Xinhe on 2019/9/9.
 */
export default {
  props: {
    size: {
      type: String,
      default: "default",
      validator(v) {
        return (
          ["large", "middle", "default", "small", "mini"].indexOf(v) !== -1
        );
      }
    }
  },
  computed: {
    smallerSize() {
      switch (this.size) {
        case "large":
          return "middle";
        case "middle":
          return "default";
        case "default":
          return "small";
        case "small":
          return "mini";
        default:
          return "mini";
      }
    }
  }
};
